export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14846.65850990.jpg";